export default class empresasService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/empresas',
			"id": '/api/empresas/:id',
			"new": '/api/empresas',
			'delete': '/api/empresas/:id',
            "update": '/api/empresas',
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

    update(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/empresasService.js